import { ADMIN_ROLES } from "../../utils/adminSession";

export const GLOBAL_TENANT_ID = "__all_tenants__";

export const GLOBAL_TENANT_ASSIGNMENT = {
  id: GLOBAL_TENANT_ID,
  tenantName: "All Tenants",
  appName: "All Apps",
  instituteName: "All Institutes",
  code: "GLOBAL",
  status: "active",        
};

export const SUPER_ADMIN_ROLE_OPTIONS = [
  { label: "Super Admin", value: ADMIN_ROLES.SUPER_ADMIN },
  { label: "Admin", value: ADMIN_ROLES.ADMIN },
];

export const SUPER_ADMIN_STATUS_OPTIONS = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const SUPER_ADMIN_FEATURE_CATALOG = [
  {
    key: "liveClasses",
    label: "Live Classes",
    category: "Learning",
    description: "Live teaching schedules, streaming access, and replay visibility.",
    defaultEnabled: true,
  },
  {
    key: "courses",
    label: "Courses",
    category: "Learning",
    description: "Course browsing, enrollment, and locked content visibility.",
    defaultEnabled: true,
  },
  {
    key: "testsQuiz",
    label: "Tests & Quiz",
    category: "Learning",
    description: "Quiz engine, timed assessments, and question practice flows.",
    defaultEnabled: true,
  },
  {
    key: "mockTests",
    label: "Mock Tests",
    category: "Learning",
    description: "Full mock-test journeys, results, and attempt analytics.",
    defaultEnabled: true,
  },
  {
    key: "notesPdfs",
    label: "Notes & PDFs",
    category: "Learning",
    description: "Study notes, PDF resources, and downloadable learning material.",
    defaultEnabled: true,
  },
  {
    key: "homework",
    label: "Homework",
    category: "Learning",
    description: "Homework assignments, submissions, and review visibility.",
    defaultEnabled: true,
  },
  {
    key: "feesPayments",
    label: "Fees & Payments",
    category: "Monetization",
    description: "Recharge, payment collection, order processing, and invoice flows.",
    defaultEnabled: true,
  },
  {
    key: "wallet",
    label: "Wallet",
    category: "Monetization",
    description: "Wallet balance, withdrawals, and unified payout actions.",
    defaultEnabled: true,
  },
  {
    key: "referral",
    label: "Referral",
    category: "Growth",
    description: "Referral earning, campaign rules, and partner conversions.",
    defaultEnabled: true,
  },
  {
    key: "leaderboard",
    label: "Leaderboard",
    category: "Growth",
    description: "Rankings, winner visibility, and competitive engagement surfaces.",
    defaultEnabled: true,
  },
  {
    key: "notices",
    label: "Notices",
    category: "Engagement",
    description: "Announcement banners, institution notices, and release messaging.",
    defaultEnabled: true,
  },
  {
    key: "attendance",
    label: "Attendance",
    category: "Engagement",
    description: "Attendance capture, reporting, and institute participation status.",
    defaultEnabled: false,
  },
  {
    key: "currentAffairs",
    label: "Current Affairs",
    category: "Engagement",
    description: "Daily current-affairs content blocks and related notifications.",
    defaultEnabled: false,
  },
  {
    key: "achievements",
    label: "Achievements",
    category: "Engagement",
    description: "Achievement badges, milestones, and student progress highlights.",
    defaultEnabled: true,
  },
  {
    key: "upcomingExams",
    label: "Upcoming Exams",
    category: "Engagement",
    description: "Upcoming exam listings, reminders, and preparation prompts.",
    defaultEnabled: true,
  },
  {
    key: "stateGk",
    label: "State GK",
    category: "Engagement",
    description: "State-wise general knowledge content and practice visibility.",
    defaultEnabled: true,
  },
  {
    key: "support",
    label: "Support",
    category: "Operations",
    description: "Help desk entry points, support contact workflows, and issue intake.",
    defaultEnabled: true,
  },
  {
    key: "chatDoubtSolving",
    label: "Chat & Doubt Solving",
    category: "Operations",
    description: "In-app chat, doubt resolution, and tutoring support channels.",
    defaultEnabled: false,
  },
  {
    key: "contests",
    label: "Contests",
    category: "Engagement",
    description: "Contest discovery, joining, results, and reward orchestration.",
    defaultEnabled: true,
  },
  {
    key: "coinTransactions",
    label: "Coin Transactions",
    category: "Operations",
    description: "Coin earning history, ledger visibility, and transaction analytics.",
    defaultEnabled: true,
  },
  {
    key: "appControls",
    label: "App Controls",
    category: "Operations",
    description: "App version controls, tutorial links, and release management settings.",
    defaultEnabled: true,
  },
  {
    key: "kyc",
    label: "KYC",
    category: "Operations",
    description: "Identity verification workflows and review queue visibility.",
    defaultEnabled: false,
  },
];

export const DEFAULT_FEATURE_FLAGS = SUPER_ADMIN_FEATURE_CATALOG.reduce(
  (accumulator, feature) => ({
    ...accumulator,
    [feature.key]: Boolean(feature.defaultEnabled),
  }),
  {},
);
